// Types
import Reducers from "app/types/Reducers";
import TrialEndActions from "app/types/TrialEndActions";
// Utilities
import asyncThunkHandler from "app/utilities/AsyncThunkHandler";
import { $get, $post, $put } from 'app/utilities/HttpClient';

const _url:string = '/management/subscriptions';

// Get subscriptions
export const getSubscriptions = asyncThunkHandler(
  `${Reducers.Subscriptions}/Get subscriptions`,
  async (params:any) => {
    const response:Response = await $get(_url, params);
    return response.json();
  }
);

// Create subscription
export const createSubscription = asyncThunkHandler(
  `${Reducers.Subscriptions}/Create subscription`,
  async (data:any) => {
    const response:Response = await $post(_url, data);
    return response.json();
  }
);

// Update subscription
export const updateSubscription = asyncThunkHandler(
  `${Reducers.Subscriptions}/Update subscription`,
  async ({ id, data }:{ id:number; data:any }) => {
    const response:Response = await $put(`${_url}/${id}`, data);
    return response.json();
  }
);

// Cancel subscription
export const cancelSubscription = asyncThunkHandler(
  `${Reducers.Subscriptions}/Cancel subscription`,
  async (id:number) => {
    const response:Response = await $post(`${_url}/${id}/actions/cancel`);
    return response.json();
  }
);

// End trial subscription
export const endTrial = asyncThunkHandler(
  `${Reducers.Subscriptions}/End trial subscription`,
  async ({ id, trialEndAction }:{ id: number; trialEndAction:TrialEndActions }) => {
    const response:Response = await $post(`${_url}/${id}/actions/endTrial`, { trialEndAction });
    return response.json();
  }
);

// Resume subscription
export const resumeSubscription = asyncThunkHandler(
  `${Reducers.Subscriptions}/Resume subscription`,
  async (id:number) => {
    const response:Response = await $post(`${_url}/${id}/actions/resume`);
    return response.json();
  }
);
